module.exports = __webpack_public_path__ + "static/media/Kolumne.d9ae9805.jpeg";